import React, { useState } from 'react'
import './Admin.css'
import { BigNumber } from 'ethers'
import { ethers } from 'ethers'
import { formatEther } from '@ethersproject/units'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MOONBASE_ADDRESS, MOONBEAM_ADDRESS } from '../constants'

const Admin = (props) => {

    const moonbase_a_vip = MOONBASE_ADDRESS;
    const moonbeam_vip = MOONBEAM_ADDRESS;

    const [ checkStatusState, setCheckStatusState ] = useState('');
    const [ checkStatusRes, setCheckStatusRes ] = useState('');

    const [ awardVipState, setAwardVipState ] = useState(
        {
            address: '',
            level : 1
        }
    );

    const [ revokeState, setRevokeState ] = useState('');

    const [ withdrawState, setWithdrawState ] = useState('');

    const checkStatusHandler = (e) => {
        setCheckStatusState(e.target.value);
    };

    const awardVipHandler = (e) => {
        setAwardVipState({...awardVipState, [e.target.name] : e.target.value});
    }

    const revokeHandler = (e) => {
        setRevokeState(e.target.value);
    }

    const checkStatusSubmitHandler = async (e) => {
        e.preventDefault();
        const result = checkStatusState;
        try {
            const res = await props.vip.getVipStatus(result);
            if( res == 0 ) {
                setCheckStatusRes('Not a VIP');
            }
            else if( res == 1 ) {
                setCheckStatusRes('VIP');
            }
            else if( res == 2 ) {
                setCheckStatusRes('Gold VIP');
            }
            else if( res == 3 ) {
                setCheckStatusRes('Diamond VIP');
            }
            toast.success('Success');
        }
        catch(err) {
            toast.error('Invalid input');
        }
    }

    const awardVipSubmitHandler = async (e) => {
        e.preventDefault();
        const result = awardVipState;
        try {
            const res = await props.vip.award(result.address, parseInt(result.level));
            toast.success('Success');
        }
        catch(err) {
            toast.error('Invalid input');
        }
    }

    const revokeSubmitHandler = async (e) => {
        e.preventDefault();
        const result = revokeState;
        try {
            const res = await props.vip.revoke(result);
            toast.success('Success');
        }
        catch(err) {
            toast.error('Invalid input');
        }
    }

    const withdrawSubmitHandler = async (e) => {
        e.preventDefault();
        try {
            const res = await props.vip.withdraw();
            toast.success('Success');
        }
        catch(err) {
            toast.error('Invalid input');
        }
    }
    
    (async () => {
        setWithdrawState(formatEther(await props.provider.getBalance(moonbase_a_vip)).toString());
    })()

    return (
        <div className="admin-container">  
            <h2>Admin functions</h2>
            <div className="admin-container-small">
                <div className="bg-info bg-gradient p-3">    
                    <h3>Look up Player VIP status:</h3>
                    <form onSubmit={checkStatusSubmitHandler}>        
                        <div className="form-group">
                            <label>PLayer address</label>
                            <input type="text" id="checkStatus" name="checkStatus" value={checkStatusState} onChange={checkStatusHandler} className='form-control w-50'></input>
                        </div>
                        <button type="submit" className="btn btn-primary text-white w-50 mt-2">Check</button>
                    </form>
                    <h4>{checkStatusRes}</h4>
                </div>
                <div className="bg-dark bg-gradient p-3">    
                    <h3>Award NFT VIP to player:</h3>
                    <form onSubmit={awardVipSubmitHandler}>        
                        <div className="form-group">
                            <label>PLayer address</label>
                            <input type="text" id="address" name="address" value={awardVipState.address} onChange={awardVipHandler} className='form-control w-50'></input>
                            <label>Membership level</label>
                            <select id="level" name="level" className="form-select w-50" onChange={awardVipHandler} value={awardVipState.level}>
                                <option value="1">VIP</option>
                                <option value="2">Gold VIP</option>
                                <option value="3">Diamond VIP</option>
                            </select>
                        </div>
                        <button type="submit" className="btn btn-primary text-white w-50 mt-2">Submit</button>
                    </form>
                </div>
            </div>
            <div className="admin-container-small">
                <div className="bg-dark bg-gradient p-3">    
                    <h3>Revoke NFT token:</h3>
                    <form onSubmit={revokeSubmitHandler}>        
                        <div className="form-group">
                            <label>PLayer address</label>
                            <input type="text" id="revoke" name="revoke" value={revokeState} onChange={revokeHandler} className='form-control w-50'></input>
                        </div>
                        <button type="submit" className="btn btn-primary text-white w-50 mt-2">Remove</button>
                    </form>
                </div>
                <div className="bg-info bg-gradient p-3">    
                    <h3>Withdraw:</h3>
                    <div className="form-group">
                        <label>{withdrawState}</label>
                    </div>
                    <button className="btn btn-primary text-white w-50 mt-2" onClick={withdrawSubmitHandler}>Withdraw</button>
                </div>
            </div>
        </div>
    )
}

export default Admin